import BRANDS from "../const/brands";

const sanitizeString = (rawInput) => {
  if (!rawInput) return "";

  return String(rawInput)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]/g, "")
    .toUpperCase();
};

const BRAND_RULES = [
  {
    match: (s) => s.includes("STARBUCKS"),
    id: BRANDS.STARBUCKS.id,
  },
  {
    match: (s) => s.includes("VIPS"),
    id: BRANDS.VIPS.id,
  },
  {
    match: (s) => s.includes("BURGERKING"),
    id: BRANDS.BURGERKING.id,
  },
  {
    match: (s) => s.includes("DOMINOS"),
    id: BRANDS.DOMINOS.id,
  },
  {
    match: (s) => s.includes("ITALIANNIS"),
    id: BRANDS.ITALIANNIS.id,
  },
  {
    match: (s) => s.includes("CHILIS"),
    id: BRANDS.CHILIS.id,
  },
  {
    match: (s) => s.includes("PFCHANGS"),
    id: BRANDS.PFCHANGS.id,
  },
  {
    match: (s) => s.includes("CHEESECAKE"),
    id: BRANDS.CHEESECAKE.id,
  },
  {
    match: (s) => s.includes("CHIPOTLE"),
    id: BRANDS.CHIPOTLE.id,
  },
  {
    match: (s) => s.includes("SAZONE"),
    id: BRANDS.SAZONE.id,
  },
  {
    match: (s) => s.includes("PORTON"),
    id: BRANDS.PORTON.id,
  },
];

export const resolveBrand = (remoteRawBrand) => {
  const cleanKey = sanitizeString(remoteRawBrand);
  const foundRule = BRAND_RULES.find((rule) => rule.match(cleanKey));

  if (foundRule) {
    return foundRule.id;
  } else {
    return null;
  }
};
